import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-facture-consolid',
  templateUrl: './facture-consolid.component.html',
  styleUrls: ['./facture-consolid.component.scss']
})
export class FactureConsolidComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
